import { observer } from 'mobx-react';
import selectReminderDefaultTimeOption from '../actions/selectReminderDefaultTimeOption';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import createReminderDropdownOptionsForSettings from 'owa-calendar-reminder-options/lib/utils/createReminderDropdownOptionsForSettings';
import { getReminderTime } from '../selectors/getReminderTime';
/**
 * Specifies the default reminder as dropdown options.
 * Provides support for rendering a custom reminder in the dropdown
 */
var dropdownOptions;
export default observer(function ReminderSelection() {
    var defaultReminderTime = getReminderTime();
    var fetchDropdownOptions = function (defaultReminderTime) {
        if (!dropdownOptions) {
            dropdownOptions = createReminderDropdownOptionsForSettings(defaultReminderTime);
        }
        return dropdownOptions;
    };
    var onReminderDefaultTimeChange = function (option) {
        selectReminderDefaultTimeOption(option.key);
    };
    return (React.createElement("div", null,
        React.createElement(Dropdown, { selectedKey: defaultReminderTime, label: strings.options_event_default_reminder, options: fetchDropdownOptions(defaultReminderTime), onChanged: onReminderDefaultTimeChange })));
});
//# sourceMappingURL=ReminderSelection.js.map